<section class="container-fluid backgroundColor shark darken-3 position-relative top-119" id="my-element">
  <div class="row">
    <div class="col-md-6 text-white no-padd img-mobile-view">
      <img src="../../assets/images/somos/faria.jpg" class="img-fluid img-penhalonga" alt="" srcset="">
    </div>
    <div class="col-md-6 text-center no-padd text-mobile-view">
      <ul class="list-group list-group-flush mt-48 mb-5">
        <li class="list-group-item textColor new-orleans base border-0">
        </li> <br><br>
        <li class="list-group-item textColor new-orleans base border-0">
          <h1>Relojoaria Faria</h1>
          <h2>História</h2>
        </li>
        <li class="list-group-item border-0 text-white">Há {{age}} anos, um dos grandes especialistas da sua área. Tudo começou com António Faria, que como relojoeiro de primeira linha desde os 12 anos decide dar início à história da relojoaria Faria em 1936. Em constante evolução desde então, o testemunho foi passado a José e Madalena Faria, que atualmente asseguram a continuidade de uma empresa familiar e tradicional, assente numa forte relação com os seus clientes e na arte de surpreender.</li>
        <!--<li class="list-group-item border-0 text-white mt-5"><img src="../../assets/images/somos/faria2.jpg" class="img-fluid" alt="" srcset=""></li>-->
      </ul>
    </div>
  </div>
</section>

<div class="backgroundColor storm-dust base">
  <section class="container-fluid backgroundColor storm-dust base position-relative top-119">
    <div class="row row-height">
      <div class="col-md-6 text-center no-padd text-mobile-view-2">
        <ul class="list-group list-group-flush mt-52">
          <li class="list-group-item border-0 text-white">Ao longo dos anos a empresa tornou-se numa referência para muitas marcas de topo da relojoaria e da joalharia internacional que fazem questão de assegurar a sua presença nas lojas de Sintra e da Penha Longa. As excecionais coleções de jóias e relógios destas marcas tornaram-se um cartão de visita que tem vindo a fidelizar gerações de clientes, ano após ano. Urna visita à relojoaria Faria é por si só uma experiência onde a competência e o profissionalismo estão associados ao belo e ao excecional.</li>
          <!--<li class="list-group-item border-0 text-white mt-5"><img src="../../assets/images/somos/faria3.jpg" class="img-fluid" alt="" srcset=""></li>-->
        </ul>
      </div>
      <div class="col-md-6 text-white no-padd img-mobile-view-2">
        <img src="../../assets/images/somos/srFaria.jpg" class="img-fluid img somos section2" alt="" srcset="">
      </div>
    </div>
  </section>
</div>